export const GENERIC_DEFAULT_ERROR_MESSAGE = 'Something went wrong';
export const GENERIC_DEFAULT_ERROR_CODE = '5000';
